import { AsyncThunkConfig, RejectValue } from '@/store/actions'
import { PromptTemplate } from '@/store/admin'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { handleError, hasError } from '@repo/shared/api/helpers'
import { PromptTemplateType } from '@repo/shared/dtos/organization'

export const promptTemplate = {
  admin: {
    init: createAsyncThunk<
      { promptTemplates: PromptTemplate[] },
      void,
      AsyncThunkConfig
    >(
      'ADMIN_INIT_PROMPTS',
      async (_, { extra, fulfillWithValue, rejectWithValue, getState }) => {
        const { api } = extra
        const organizationId = getState().user.currentOrganizationId
        if (!organizationId) return rejectWithValue(RejectValue.NoOrganization)

        const promptTemplates = await api.admin.prompts.templates.get({
          organizationId,
        })
        if (hasError(promptTemplates))
          return rejectWithValue(handleError(promptTemplates))
        return fulfillWithValue({ promptTemplates })
      },
    ),

    updateTemplate: createAsyncThunk<
      { promptTemplate: PromptTemplate },
      {
        promptText: string
        promptTemplateType: PromptTemplateType
      },
      AsyncThunkConfig
    >(
      'ADMIN_UPDATE_PROMPT_TEMPLATE',
      async (
        { promptText, promptTemplateType },
        { extra, fulfillWithValue, rejectWithValue, getState },
      ) => {
        const { api } = extra
        const organizationId = getState().user.currentOrganizationId
        if (!organizationId) return rejectWithValue(RejectValue.NoOrganization)

        const promptTemplateId = (
          getState().admin.promptTemplates as {
            [key in PromptTemplateType]?: PromptTemplate
          }
        )[promptTemplateType]!.id
        const promptTemplate = await api.admin.prompts.templates.patchOne({
          organizationId,
          promptTemplateId,
          fields: { promptText },
          promptTemplateType,
        })
        if (hasError(promptTemplate))
          return rejectWithValue(handleError(promptTemplate))
        return fulfillWithValue({ promptTemplate })
      },
    ),
  },
}
